

let localhost = 'http://192.168.0.187:8087';//로컬 테스트 196
// let localhost = 'http://localhost:8087';//로컬 테스트 
// let localhost = 'http://211.44.220.121:9981';//로컬 테스트 

let host = process.env.VUE_APP_HOST_API;

const hostApi = (process.env.NODE_ENV === 'production') ? host : localhost;

export {
  hostApi,
}
